import React from 'react';
import { makePopup } from '@typeform/embed';
export const TypeformPopup = ({ url, children, mode = 'popup', autoOpen = false, autoClose = 3000, hideHeaders = true, hideFooter = false, onSubmit = () => undefined, hiddenFields = {}, }) => {
    const fullUrl = makeTypeFormUrl(url, hiddenFields);
    const openPopup = () => {
        const typeformPopup = makePopup(fullUrl, {
            mode,
            autoOpen,
            autoClose,
            hideHeaders,
            hideFooter,
            onSubmit,
        });
        typeformPopup.open();
    };
    return (React.createElement("div", { tabIndex: 0, role: "button", onClick: () => openPopup(), onKeyDown: (event) => {
            if (event.key === 'Enter') {
                openPopup();
            }
        } }, children));
};
export const makeTypeFormUrl = (rootUrl, hiddenFields) => {
    const hiddenFieldsString = new URLSearchParams(hiddenFields).toString();
    return hiddenFieldsString ? `${rootUrl}?${hiddenFieldsString}` : rootUrl;
};
